import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	agentPickerErrorFlagDescription: {
		id: 'autodev.agent-picker.trigger-agent-error-flag-description',
		defaultMessage: 'Something went wrong. Please try again.',
		description: 'Description for the error flag',
	},
	agentPickerErrorFlagTitle: {
		id: 'autodev.agent-picker.trigger-agent-error-flag-title',
		defaultMessage: 'Failed to trigger the Rovo agent',
		description: 'Title for the error flag',
	},
	agentPickerErrorFlagAction: {
		id: 'autodev.agent-picker.trigger-agent-error-flag-action',
		defaultMessage: 'Review error in Rovo chat',
		description: 'Action for the error flag',
	},
	agentPickerInBulkAllSuccessFlagTitle: {
		id: 'autodev.agent-picker.trigger-agent-all-success-flag-title',
		defaultMessage:
			'"{agentName}" is coding {issueCount} work {issueCount, plural, one {item} other {items}}',
		description:
			'The title of the flag that notifies user that all the issues has been successful to trigger the given Rovo agent',
	},
	agentPickerInBulkAllSuccessFlagDescriptionBeforeDevHub: {
		id: 'autodev.agent-picker.trigger-agent-all-success-flag-description-before-devhub',
		defaultMessage: 'Check each work item to see the progress.',
		description:
			'The description of the flag that notifies user that all the issues has been successful to trigger the given Rovo agent, and user must go to an each issue to see the generated code',
	},
	agentPickerInBulkStartInfoFlagTitle: {
		id: 'autodev.agent-picker.trigger-agent-start-info-flag-in-bulk-title',
		defaultMessage:
			'Asking "{agentName}" to code {issueCount} work {issueCount, plural, one {item} other {items}}',
		description:
			'Title for the info flag when triggering agents in bulk to let users know that we will send notification about the task that has been just triggered.',
	},
	agentPickerInBulkStartInfoFlagDescription: {
		id: 'autodev.agent-picker.trigger-agent-start-info-flag-in-bulk-description',
		defaultMessage: "We'll let you know when they're ready to review.",
		description:
			'Description for the info flag when triggering agents in bulk to let users know that we will send notification about the task that has been just triggered.',
	},
	viewInDevelopment: {
		id: 'autodev.agent-picker.trigger-agent-view-in-development',
		defaultMessage: 'View in Development',
		description:
			'The link label to go to Development page to see the result of bulk agent Rovo Autodev run.',
	},
	agentPickerInBulkAttemptedOverLimitFlagTitle: {
		id: 'autodev.agent-picker.trigger-agent-in-bulk-attempted-over-limit-flag-title',
		defaultMessage: 'Bulk limit is applied',
		description:
			'The message title to display when user attempts to trigger an agent over the number limit of the work items',
	},
	agentPickerInBulkAttemptedOverLimitFlagDescription: {
		id: 'autodev.agent-picker.trigger-agent-in-bulk-attempted-over-limit-flag-description',
		defaultMessage:
			'Sorry, we support up to {limit} work {limit, plural, one {item} other {items}} for bulk run.',
		description:
			'The message description to display when user attempts to trigger an agent over the number limit of the work items',
	},
	agentPickerInBulkAttemptedOverLimitFlagDescription2: {
		id: 'autodev.agent-picker.trigger-agent-in-bulk-attempted-over-limit-flag-description2',
		defaultMessage:
			'Please try to select less than or equal to {limit} work {limit, plural, one {item} other {items}}',
		description:
			'The message description to display when user attempts to trigger an agent over the number limit of the work items',
	},
	agentPickerInBulkErrorUnexpectedFlagTitle: {
		id: 'autodev.agent-picker.trigger-agent-unexpected-error-flag-in-bulk-title',
		defaultMessage: 'Something went wrong. Please try again or contact support for help.',
		description: 'Title for the error flag when triggering agents in bulk',
	},
	agentPickerInBulkErrorFlagTitle: {
		id: 'autodev.agent-picker.trigger-agent-error-flag-in-bulk-title',
		defaultMessage:
			'"{agentName}" couldn\'t generate code for {errorIssueCount} {errorIssueCount, plural, one {work item} other {work items}}.',
		description: 'Title for the error flag when triggering agents in bulk',
	},
	agentPickerInBulkErrorFlagDescription: {
		id: 'autodev.agent-picker.trigger-agent-error-flag-in-bulk-description',
		defaultMessage: 'Chat to the agent:',
		description: 'Title for the error flag when triggering agents in bulk',
	},
	agentPickerInBulkErrorFlagDescriptionManyFailure: {
		id: 'autodev.agent-picker.trigger-agent-error-flag-in-bulk-description-many-failure',
		defaultMessage:
			'We will send Jira/email notifications soon with links to chat with the agent for each work item.',
		description: 'Title for the error flag when triggering agents in bulk',
	},
	triggerPlaceholder: {
		id: 'autodev.agent-picker.trigger-placeholder',
		defaultMessage: 'Search agents',
		description:
			'The placeholder of search text input that searches agents by user text input. Agent is a pronoun that refers Rovo agent that is a A.I. tool Atlassian has.',
	},
	suggestedAgents: {
		id: 'autodev.agent-picker.suggested-agents',
		defaultMessage: 'Suggested agents',
		description:
			'Header of the section inside the dropdown of the agent picker that contains the suggested agents. Agent is a pronoun that refers Rovo agent that is a A.I. tool Atlassian has.',
	},
	codingAgents: {
		id: 'autodev.agent-picker.coding-agents',
		defaultMessage: 'Coding agents',
		description:
			'Header of the section inside the dropdown of the agent picker that contains the coding agents. Agent is a pronoun that refers Rovo agent that is a A.I. tool Atlassian has. This heading is only applied when agents rankings are not available due to high number of agents in the tenant.',
	},
	runAiCodingToolButtonLabel: {
		id: 'autodev.agent-picker.run-ai-coding-tool-button-label',
		defaultMessage: 'Use AI coding tool',
		description:
			'The label of the button that runs the Coding with AI process with the selected Rovo agent.',
	},
	runAiCodingToolButtonSubheading: {
		id: 'autodev.agent-picker.run-ai-coding-tool-button-subheading',
		defaultMessage: "Can't find an agent for your task?",
		description:
			'The subheading of the button that runs the Coding with AI process with the selected Rovo agent.',
	},
	newLozengeLabel: {
		id: 'autodev.agent-picker.new-lozenge-label',
		defaultMessage: 'new',
		description:
			'The label of lozenge that indicates Autodev Rovo agent is a new feature. Displayed all in capital letters',
	},
});
